(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  class FeaturedProducts extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.slider');
      if (this.slider) {
        this.initSlider();
      }
    }

    initSlider() {
      let isDown = false;
      let startX;
      let scrollLeft;

      this.slider.addEventListener('mousedown', (e) => {
        isDown = true;
        this.slider.classList.add('active');
        startX = e.pageX - this.slider.offsetLeft;
        scrollLeft = this.slider.scrollLeft;
      });

      this.slider.addEventListener('mouseleave', () => {
        isDown = false;
        this.slider.classList.remove('active');
      });

      this.slider.addEventListener('mouseup', () => {
        isDown = false;
        this.slider.classList.remove('active');
      });

      this.slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - this.slider.offsetLeft;
        const walk = (x - startX) * 2;
        this.slider.scrollLeft = scrollLeft - walk;
      });
    }
  }

  customElements.define('featured-products', FeaturedProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class Hero extends HTMLElement {
    constructor() {
      super();
      this.media = this.querySelector('.hero__media');
    }
  }

  customElements.define('hero-section', Hero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-custom-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isHomepage = this.headerWrapper.hasAttribute('data-is-homepage');
      this.transparentHomepage = this.headerWrapper.classList.contains('transparent-homepage');
      this.colorScheme = this.headerWrapper.getAttribute('data-color-scheme');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isHomepage && this.transparentHomepage) {
        if (scrollTop > 50) {
          this.headerWrapper.classList.add('scrolled');
          this.headerWrapper.classList.add('color-scheme-1');
          this.headerWrapper.classList.add('gradient');
          this.headerWrapper.style.background = 'var(--gradient-background)';
        } else {
          this.headerWrapper.classList.remove('scrolled');
          this.headerWrapper.classList.remove('color-scheme-1');
          this.headerWrapper.classList.remove('gradient');
          this.headerWrapper.style.background = 'transparent';
        }
      }

      if (scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.headerIsAlwaysSticky) {
          if (scrollTop > this.currentScrollTop) {
            if (this.preventHide) return;
            requestAnimationFrame(this.hide.bind(this));
          } else {
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          }
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if (!this.headerIsAlwaysSticky) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-custom-hero"] && !Shopify.designMode) return;
  try {
    
  class CustomVideo extends HTMLElement {
    constructor() {
      super();
      this.section = this.querySelector('.custom-video');
      this.wrapper = this;
      this.video = this.querySelector('video');
      this.pauseButton = this.querySelector('.video-pause-button');

      if (this.section) {
        this.applyDynamicStyles();
        this.setupEventListeners();
        this.setupVideoControls();
        this.setupHeaderOverlap();
        if (this.dataset.enableSnap === 'true') {
          this.setupScrollSnapping();
        }
      }

      // Listen for theme editor messages
      window.addEventListener('message', (event) => {
        if (
          event.data.type === 'theme:section:select' ||
          event.data.type === 'shopify:section:select' ||
          event.data.type === 'theme:section:settings' ||
          event.data.type === 'shopify:section:settings'
        ) {
          // Check if this is our section
          if (event.data.sectionId === this.getAttribute('data-section-id')) {
            // If we have video speed in the settings update
            if (event.data.settings && typeof event.data.settings.video_playback_speed !== 'undefined') {
              const newSpeed = parseFloat(event.data.settings.video_playback_speed);
              if (this.video && !isNaN(newSpeed)) {
                this.video.playbackRate = newSpeed;
                this.video.dataset.speed = newSpeed;
              }
            }
          }
        }
      });
    }

    setupHeaderOverlap() {
      const header = document.querySelector('.header-wrapper');
      if (!header) return;

      const updateOverlap = () => {
        const overlaps = this.section.dataset.overlapHeader === 'true';
        const headerHeight = parseInt(this.section.dataset.headerHeight || 0);
        const manualHeight = parseInt(this.section.dataset.headerHeightManual || 0);
        const height = manualHeight > 0 ? manualHeight : headerHeight;

        if (overlaps) {
          this.section.style.marginTop = `-${height}px`;
          this.section.parentElement.style.marginTop = `${height}px`;
          // Add transparent class to header
          header.classList.add('header--transparent');
        } else {
          this.section.style.marginTop = '0';
          this.section.parentElement.style.marginTop = '0';
          // Remove transparent class from header
          header.classList.remove('header--transparent');
        }
      };

      // Initial setup
      updateOverlap();

      // Update on resize
      window.addEventListener('resize', updateOverlap);

      // Update when header changes
      const observer = new MutationObserver(updateOverlap);
      observer.observe(header, { attributes: true, attributeFilter: ['class'] });
    }

    applyDynamicStyles() {
      const manual = parseInt(this.section.dataset.headerHeightManual || 0);
      const slider = parseInt(this.section.dataset.headerHeight || 0);
      const height = manual > 0 ? manual : slider;
      const overlaps = this.section.dataset.overlapHeader === 'true';

      if (overlaps) {
        this.section.classList.add('overlap-header');
        this.section.style.zIndex = '0';
        this.section.style.marginTop = `-${height}px`;
        this.section.parentElement.style.marginTop = `${height}px`;
      } else {
        this.section.classList.remove('overlap-header');
        this.section.style.zIndex = '';
        this.section.style.marginTop = '0';
        this.section.parentElement.style.marginTop = '0';
      }

      // Mobile adjustments
      if (window.innerWidth <= 749) {
        this.section.style.marginTop = '0';
        this.section.parentElement.style.marginTop = '0';
      }

      if (this.section.classList.contains('custom-video-full')) {
        const vh = window.innerHeight;
        this.section.style.height = `${vh}px`;
      }

      const headingEl = this.section.querySelector('.custom-video__heading');
      const subtextEl = this.section.querySelector('.custom-video__subtext');

      if (headingEl) headingEl.style.fontSize = `${this.section.dataset.headingSize}px`;
      if (subtextEl) subtextEl.style.fontSize = `${this.section.dataset.subtextSize}px`;
    }

    setupEventListeners() {
      window.addEventListener('resize', this.applyDynamicStyles.bind(this));
      document.addEventListener('shopify:section:load', this.applyDynamicStyles.bind(this));
      document.addEventListener('shopify:section:select', this.applyDynamicStyles.bind(this));
      document.addEventListener('shopify:section:deselect', this.applyDynamicStyles.bind(this));
      document.addEventListener('shopify:block:select', this.applyDynamicStyles.bind(this));
      document.addEventListener('shopify:block:deselect', this.applyDynamicStyles.bind(this));
    }

    setupScrollSnapping() {
      if (this.dataset.enableSnap !== 'true') return;

      let lastScrollTime = 0;
      const scrollCooldown = 500;

      this.wheelHandler = (e) => {
        const now = Date.now();
        if (now - lastScrollTime < scrollCooldown) {
          e.preventDefault();
          return;
        }

        const rect = this.getBoundingClientRect();
        const visibleRatio = Math.abs(rect.top) < window.innerHeight / 2;

        if (visibleRatio) {
          const direction = e.deltaY > 0 ? 1 : -1;
          const nextSection = this.findNextScrollTarget(direction);

          if (nextSection) {
            e.preventDefault();
            nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            lastScrollTime = now;
          }
        }
      };

      window.addEventListener('wheel', this.wheelHandler, { passive: false });
    }

    findNextScrollTarget(direction) {
      const allSections = Array.from(document.querySelectorAll('.custom-video-wrapper'));
      const currentIndex = allSections.indexOf(this);

      if (direction > 0) {
        // Looking for next section
        for (let i = currentIndex + 1; i < allSections.length; i++) {
          const section = allSections[i];
          if (section.dataset.enableSnap === 'true') {
            return section;
          }
        }
        // If no next snap section found, return null to allow normal scrolling
        return null;
      } else {
        // Looking for previous section
        for (let i = currentIndex - 1; i >= 0; i--) {
          const section = allSections[i];
          if (section.dataset.enableSnap === 'true') {
            return section;
          }
        }
        // If no previous snap section found, return null to allow normal scrolling
        return null;
      }
    }

    disconnectedCallback() {
      if (this.wheelHandler) {
        window.removeEventListener('wheel', this.wheelHandler);
      }
    }

    setupVideoControls() {
      if (this.video && this.pauseButton) {
        // Set initial playback speed
        const speed = parseFloat(this.video.dataset.speed || '1.0');
        this.video.playbackRate = speed;

        // Handle pause/play button
        this.pauseButton.addEventListener('click', () => {
          if (this.video.paused) {
            this.video.play();
            this.pauseButton.classList.remove('paused');
          } else {
            this.video.pause();
            this.pauseButton.classList.add('paused');
          }
        });

        // Update button state when video naturally ends
        this.video.addEventListener('ended', () => {
          this.pauseButton.classList.add('paused');
        });

        // Ensure speed stays correct after any play event
        this.video.addEventListener('play', () => {
          const currentSpeed = parseFloat(this.video.dataset.speed || '1.0');
          this.video.playbackRate = currentSpeed;
        });
      }
    }
  }

  customElements.define('custom-video-section', CustomVideo);

  // Add this to handle the conditional display of the left image width setting
  document.addEventListener('DOMContentLoaded', function () {
    const ratioSelect = document.querySelector('[name="side_image_ratio"]');
    const leftWidthSetting = document.querySelector('.side-image-ratio-custom');

    if (ratioSelect && leftWidthSetting) {
      function toggleLeftWidth() {
        if (ratioSelect.value === 'custom') {
          leftWidthSetting.style.display = 'block';
        } else {
          leftWidthSetting.style.display = 'none';
        }
      }

      // Initial state
      toggleLeftWidth();

      // Listen for changes
      ratioSelect.addEventListener('change', toggleLeftWidth);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    // Wait until the video elements are loaded
    setTimeout(() => {
      // Select all video elements inside the section
      const videos = document.querySelectorAll('.custom-video__background');

      if (videos.length === 0) {
        console.warn('No videos found in the section.');
        return;
      }

      videos.forEach((video) => {
        // Get video speed from data attribute
        const videoSpeed = parseFloat(video.dataset.speed || '1.0');

        if (video.readyState >= 2) {
          video.playbackRate = videoSpeed;
        } else {
          video.addEventListener('loadeddata', function () {
            video.playbackRate = videoSpeed;
          });
        }

        // Ensure speed stays correct even if autoplay restarts
        video.addEventListener('play', function () {
          video.playbackRate = videoSpeed;
        });

        // Handle pause/play button
        const pauseButton = video.nextElementSibling;
        if (pauseButton && pauseButton.classList.contains('video-pause-button')) {
          pauseButton.addEventListener('click', () => {
            if (video.paused) {
              video.play();
              pauseButton.classList.remove('paused');
            } else {
              video.pause();
              pauseButton.classList.add('paused');
            }
          });

          // Update button state when video naturally ends
          video.addEventListener('ended', () => {
            pauseButton.classList.add('paused');
          });
        }
      });

      console.log('Video speed set to:', videoSpeed);
    }, 500); // Delay to ensure videos are loaded
  });

  class ImageSlider {
    constructor(container) {
      this.container = container;
      this.slides = Array.from(container.querySelectorAll('.custom-video__slide'));
      this.dots = Array.from(container.querySelectorAll('.custom-video__slider-dot'));
      this.prevButton = container.querySelector('.custom-video__slider-button.prev');
      this.nextButton = container.querySelector('.custom-video__slider-button.next');
      this.currentIndex = 0;
      this.isAutoplay = container.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(container.dataset.autoplaySpeed) || 5000;
      this.autoplayInterval = null;
      this.isTransitioning = false;

      this.init();
    }

    init() {
      if (this.slides.length <= 1) return;

      // Remove active class from all slides except first
      this.slides.forEach((slide, index) => {
        if (index !== 0) {
          slide.classList.remove('active');
        }
      });

      // Setup navigation
      if (this.prevButton && this.nextButton) {
        this.prevButton.addEventListener('click', () => this.navigate('prev'));
        this.nextButton.addEventListener('click', () => this.navigate('next'));
      }

      // Setup dots
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Setup autoplay
      if (this.isAutoplay) {
        this.startAutoplay();

        this.container.addEventListener('mouseenter', () => this.stopAutoplay());
        this.container.addEventListener('mouseleave', () => this.startAutoplay());
      }

      // Touch events
      let touchStartX = 0;
      let touchEndX = 0;

      this.container.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
        this.stopAutoplay();
      });

      this.container.addEventListener('touchmove', (e) => {
        touchEndX = e.touches[0].clientX;
      });

      this.container.addEventListener('touchend', () => {
        const difference = touchStartX - touchEndX;
        if (Math.abs(difference) > 50) {
          if (difference > 0) {
            this.navigate('next');
          } else {
            this.navigate('prev');
          }
        }
        if (this.isAutoplay) this.startAutoplay();
      });
    }

    navigate(direction) {
      if (this.isTransitioning) return;

      this.stopAutoplay();
      let newIndex;

      if (direction === 'prev') {
        newIndex = this.currentIndex - 1;
        if (newIndex < 0) newIndex = this.slides.length - 1;
      } else {
        newIndex = this.currentIndex + 1;
        if (newIndex >= this.slides.length) newIndex = 0;
      }

      this.goToSlide(newIndex);

      if (this.isAutoplay) {
        this.startAutoplay();
      }
    }

    goToSlide(index) {
      if (this.isTransitioning || index === this.currentIndex) return;

      this.isTransitioning = true;

      // Remove active class from current slide and dot
      this.slides[this.currentIndex].classList.remove('active');
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.remove('active');
      }

      // Add active class to new slide and dot
      this.slides[index].classList.add('active');
      if (this.dots[index]) {
        this.dots[index].classList.add('active');
      }

      this.currentIndex = index;

      // Reset transition lock after animation completes
      setTimeout(() => {
        this.isTransitioning = false;
      }, 500);
    }

    startAutoplay() {
      if (!this.isAutoplay || this.autoplayInterval) return;

      this.autoplayInterval = setInterval(() => {
        this.navigate('next');
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.custom-video__slider');
    sliders.forEach((slider) => new ImageSlider(slider));
  });

  } catch(e) { console.error(e); }
})();
})();
